import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import Language from './Language';
import Theme from './Theme'; 
import DataBox from '../../general/data/DataBox';
import InfoRow from '../../general/inputs/InfoRow';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import Button from '../../general/inputs/Button';
import { setIsLanguagePopupOpened } from '../../../redux/features/general/navigation';


const Preferences: React.FC = () => {

  const dispatch = useAppDispatch(); 
  const { t, i18n } = useTranslation();

  const colors = useAppSelector(state => state.theme.colors); 
  const accountInfo = useAppSelector((state) => state.meta.accountInfo);
  const isMobile = useMediaQuery('(max-width:600px)');

  // -- 

  const handleLanguageSelection = () => { 

    dispatch(setIsLanguagePopupOpened(true)); 

  }; 

  // -- 

  return (

    <Box sx={{ 
        width: '100%',
        height: '100%',
        padding: isMobile ? '2vh 4vw' : '3vh 6vw',
        boxSizing: 'border-box',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
    }}>

      <DataBox>

          <InfoRow 
            title='language'
            icon={<PublicOutlinedIcon sx={{ color: colors?.main }} />}
            description={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{ color: 'rgb(150, 150, 150)' }}>
                  {t(i18n?.language)}
                </Box>
                <Button 
                  title='update'
                  triggerFunction={handleLanguageSelection}
                  extraStyle={{ marginTop: 0 }}
                />
              </Box>
            }
            isDisabled
          />

      </DataBox>

        {/* <Language /> 

        <Theme />  */}

    </Box>

  );

};

export default Preferences;